export default "__VITE_ASSET__DBaqIGeE__"